export const WHITE = '#f2f2f2'
export const GRAY = '#808080'
export const BLACK = '#333333'

export const MINT = '#60ae9f'
export const PURPLE = '#8c4d94'
export const RED = '#e7334e'
